import styled from "styled-components";
import Accordion from "../Accordion";

const accordionContent = [
  {
    heading:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. A, modi.",
    desc: " Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
  },
  {
    heading:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. A, modi.",
    desc: " Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
  },
];

const FaqAndTips = () => {
  return (
    <Card>
      <TopBar>
        <img src="/img/helpful-tips.svg" alt="" />
        <div>
          <h6 style={{ color: "#ffffff" }}>FAQ & Tips</h6>
          <p style={{  margin: "0px !important"}}>quickly find the help you need</p>
        </div>
        <img
          style={{ justifySelf: "flex-end" }}
          src="/img/Group 27407.svg"
          alt=""
        />
      </TopBar>
      <InnerContent>
        <Accordion content={accordionContent} />
        <div
          style={{
            marginTop: "4%",
            display: "flex",
            justifyContent: "center",
            paddingBottom: "4%",
          }}
        >
          <SeeMoreBtn>View More</SeeMoreBtn>
        </div>
      </InnerContent>
    </Card>
  );
};

const SeeMoreBtn = styled.button`
  border: 2px solid #01d6c0;
  border-radius: 50px;
  font-weight: 600;
  background-color: #c5f0eb;
  padding: 1% 3%;

  &:hover {
    background-color: #01d6c0;
  }
`;

const Text = styled.p`
  font-weight: 600;
`;

const InnerContent = styled.div`
  padding: 4% 4% 6% 4%;
`;

const TopBar = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: #0d233f;
  padding: 0% 4%;
  align-items: center;
  & img {
    height: 3rem;
    width: 3rem;
  }

  & > div {
    color: white;
    text-align: center;
  }

  & > div > h3 {
    font-weight: 600;
  }

  & > div > p {
    color: #ccd0d2;
  }
`;

const Card = styled.div`
  background-color: white;
`;

export default FaqAndTips;
